/* src/app/modules/finanzas/bancos/bankaccount.component.css */
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__icon-wrap--red {
  background: rgba(220, 38, 38, .12);
}
.dlg-hdr__icon-wrap--red mat-icon {
  color: #dc2626;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
  flex-shrink: 0;
}
.dlg-body {
  padding: 24px 24px 8px !important;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.dlg-btn-delete {
  background-color: #dc2626 !important;
  color: #fff !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.delete-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #fff8f8;
  border: 1px solid #fecaca;
  border-radius: 8px;
}
.delete-info mat-icon {
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 2px;
}
.delete-info__text {
  font-size: 14px;
  color: #1a1d23;
  line-height: 1.5;
}
.delete-info--success {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.delete-info--success mat-icon {
  color: #16a34a;
}
.delete-info--info {
  background: #f4f6f8;
  border-color: #e5e7eb;
}
.delete-info--info mat-icon {
  color: #6b7280;
}
.dlg-empty-list {
  padding: 8px 0 4px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
}
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
/*# sourceMappingURL=bankaccount.component.css.map */
